import script from "./CopyrightComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyrightComponent.vue?vue&type=script&setup=true&lang=js"

import "./CopyrightComponent.vue?vue&type=style&index=0&id=12785b4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12785b4c"]])

export default __exports__